import { Node, mergeAttributes } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-2';
import CustomTagsAndFields from '../customoptions/CustomTagsAndFields.vue';

export default Node.create({
    name: 'customTagsAndFields',
    group: 'inline',
    inline: true,
    selectable: false,
    atom: true,

    parseHTML() {
        return [
            {
                tag: 'span.custom-tags-and-fields__default',
                getAttrs: (element) => ({
                    label: element.innerText,
                    tag: element.getAttribute('tag'),
                }),
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'span',
            mergeAttributes(HTMLAttributes, {
                class: 'custom-tags-and-fields custom-tags-and-fields__default',
                tag: HTMLAttributes.tag || '',
            }),
            HTMLAttributes.label || 'default',
        ];
    },

    addNodeView() {
        return VueNodeViewRenderer(CustomTagsAndFields, {
            stopEvent() {
                return false;
            },
        });
    },

    addAttributes() {
        return {
            type: {
                default: 'default',
            },
            label: {
                default: 'default',
            },
            tag: {
                default: '',
            },
            isDraggable: {
                default: true,
            },
            isHovered: {
                default: false,
            },
            isFocused: {
                default: false,
            },
            isDisabled: {
                default: false,
            },
        };
    },

    addCommands() {
        return {
            insertCustomTagsAndFields:
                (props) =>
                ({ tr, commands }) => {
                    const { $from } = tr.selection;
                    const from = tr.mapping.map($from.pos);
                    commands.insertContentAt(from, {
                        type: this.name,
                        attrs: props,
                    }),
                        {
                            parseOptions: {
                                preserveWhitespace: 'full',
                            },
                        };
                    return true;
                },
        };
    },
});
